import { Injectable } from '@angular/core';

@Injectable()
export class ValidateDataService {

  constructor() { }

  validateFormFields(model: any, objectfilelds: string[]) {
    let fields: string[] = objectfilelds;
    let errorFields: string[];
    errorFields = [];
    for (let objField of fields) {
      if (model[objField.toLowerCase()] === undefined || model[objField.toLowerCase()] === "-1"
        || model[objField.toLowerCase()] === null || model[objField.toLowerCase()] === "") {
        errorFields.push(objField);
      }
    }
    return errorFields;
  }

  validateDetailedQuotaForm(model: any) {
    let errorMessage: string;
    errorMessage = "";
    if (model['variablepay'] <= 0)
      return "Variable Pay should be greater than zero";
    else if (model['variablepaycurrency'].length != 3)
      return "Invalid Variable Pay Currency";
    else if (model['plantype'].length <= 0)
      return "Invalid Variable Plan Type";
    else if (model['totalquota'] <= 0)
      return "Invalid Total Quota";
    return "";
  }

  CheckIsValidDate(DateVal: string): boolean {
    if (DateVal.match(/^(?:(0[1-9]|1[012])[\- \/.](0[1-9]|[12][0-9]|3[01])[\- \/.](19|20)[0-9]{2})$/)) {
      return true;
    }
    else {
      return false;
    }
  }
}

